import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addWasteRecycle = (wasteRecycle) => {
  wasteRecycle = Object.assign({}, wasteRecycle)
  const promises = [];
  return http
    .post("/waste-recycle/create", {
      cityId:wasteRecycle.cityId,
      wasteCollectionArea: wasteRecycle.wasteCollectionArea,
      segregationPlant: wasteRecycle.segregationPlant,
      amount: wasteRecycle.amount,
      vendor: wasteRecycle.vendor,
      memo: wasteRecycle.memo,
      memoPicture: wasteRecycle.memoPicture,
      contactNumber: wasteRecycle.contactNumber,
    })
    .then((result) => {
      wasteRecycle = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      throw error;
    });
};

internals.updateWasteRecycle = (_id,wasteRecycle) => {
  return http
    .put(`/waste-recycle/update`, {
      _id: wasteRecycle._id,
      cityId:wasteRecycle.cityId,
      wasteCollectionArea: wasteRecycle.wasteCollectionArea,
      segregationPlant: wasteRecycle.segregationPlant,
      amount: wasteRecycle.amount,
      vendor: wasteRecycle.vendor,
      memo: wasteRecycle.memo,
      memoPicture: wasteRecycle.memoPicture,
      contactNumber: wasteRecycle.contactNumber,
    })
    .then((result) => {
        wasteRecycle = result.data;
      return wasteRecycle;
    })
    .catch((error) => {
      throw error;
    });
};

internals.deleteWasteRecycle = (_id) => {  
  return http
    .delete(`/waste-recycle/delete?_id=`+ _id,  
    )
    .then((result) => {      
      return result;
    })
    .catch((error) => {
      throw error;
    });
};

internals.getById = (_id) => {  
  return http
    .get(`/waste-recycle/getById?_id=`+ _id,  
    )
    .then((result) => {      
      return result;
    })
    .catch((error) => {
      throw error;
    });
};


internals.getwasteCollection = Id => {
  return http
    .get(`/waste-collectionbyId?id=${Id}`)
    .then(response => {
      return response
    })
    .catch(error => {
      throw error
    })
}


internals.getWasteCollectionAreaList = Id => {
  return http
    .get(`/waste-collection-area-list?cityId=${Id}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('wasteRecycleService-error:\n', error)
      throw error
    })
}



export default internals;



// WEBPACK FOOTER //
// ./src/services/wasterecycle.service.js